import { useEffect, useState } from 'react'
import { BREAKPOINTS } from '@/lib/utils/responsive'

export const BELOW_LG_MEDIA_QUERY = `(max-width: ${BREAKPOINTS.lg - 1}px)`

/**
 * True when viewport is below Tailwind `lg` (<1024px).
 * Matches ReimbursementFormStickyLayout column stacking breakpoint.
 */
export function useIsBelowLg(): boolean {
  const [isBelowLg, setIsBelowLg] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(BELOW_LG_MEDIA_QUERY).matches
  })

  useEffect(() => {
    const mediaQuery = window.matchMedia(BELOW_LG_MEDIA_QUERY)
    const sync = () => setIsBelowLg(mediaQuery.matches)

    sync()
    mediaQuery.addEventListener('change', sync)
    return () => mediaQuery.removeEventListener('change', sync)
  }, [])

  return isBelowLg
}
